<template>
  <div>
    <interview-route-change-modal
      :show-route-change-modal="showRouteChangeModal"
      @leavePage="routerNext()"
      @stayPage="showRouteChangeModal = false"
    />
    <InterviewCandidateVideoDetail v-if="type === 1 && interviewCandidateInfo" @changeNoteStatus="changeNoteStatus" :interview-candidate-info="interviewCandidateInfo"/>
    <InterviewCandidateText v-else-if="(type === 3 || type === 4) && interviewCandidateInfo" @changeAnswerStatus="changeAnswerStatus" :interview-candidate-info="interviewCandidateInfo"/>
  </div>
</template>

<script>
import InterviewCandidateVideoDetail from './interviewCandidateDetail/interviewCandidateVideoDetail.vue';
import InterviewCandidateText from './interviewCandidateDetail/interviewCandidateText.vue';
import hrvenueService from '../../services/hrvenue.service';

export default {
  name: 'InterviewCandidateDetail',

  components: {
    InterviewCandidateVideoDetail,
    InterviewCandidateText,
    InterviewRouteChangeModal: () => import('./interviewCandidateDetail/interviewCandidateRouteChangeModal.vue'),
  },

  data() {
    return {
      loading: false,
      type: 0,
      interviewCandidateInfo: null,
      interviewCandidateLogId: '',
      showRouteChangeModal: false,
      routerNext: null,
      noteChanged: false,
      answersChanged: false,
    };
  },

  computed: {
    uit() {
      return this.$route.query.uit;
    },
  },

  async created() {
    try {
      this.interviewCandidateLogId = this.$route.params.interviewCandidateLogId;

      this.interviewCandidateInfo = await hrvenueService.getInterviewOfCandidate(this.interviewCandidateLogId, this.uit);
      this.type = this.interviewCandidateInfo.interviewCandidateLog.interviewType || this.$route.params.type;
    } catch (error) {
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({
        name: 'HrVenueView',
        params: { lang },
      });
    }
  },

  methods: {
    changeNoteStatus(val) {
      this.noteChanged = val;
    },
    changeAnswerStatus(val) {
      this.answersChanged = val;
    },
  },

  beforeRouteLeave(to, from, next) {
    if (this.noteChanged || this.answersChanged) {
      this.showRouteChangeModal = true;
      this.routerNext = next;
      next(false);
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
@import '~@/style/starter.scss';
</style>
